import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider, useAuth } from "./context/AuthContext";
import { GuestAuthProvider } from "./context/GuestAuthContext";
import Homepage from "./pages/Homepage";
import PropertyListing from "./pages/PropertyListing";
import PropertyDetail from "./pages/PropertyDetail";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminProperties from "./pages/AdminProperties";
import AdminLeads from "./pages/AdminLeads";
import PropertyForm from "./pages/PropertyForm";
import ScrollToTop from "./components/ScrollToTop";
import PhoneGate from "./components/PhoneGate";

const ProtectedAdmin = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-gray-500">Loading...</p>
      </div>
    );
  }
  if (!isAuthenticated) return <Navigate to="/admin/login" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <GuestAuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Toaster position="top-right" richColors />
          <PhoneGate />
          <Routes>
            {/* Public */}
            <Route path="/" element={<Homepage />} />
            <Route path="/properties" element={<PropertyListing />} />
            <Route path="/property/:id" element={<PropertyDetail />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />

            {/* Admin */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedAdmin><AdminDashboard /></ProtectedAdmin>} />
            <Route path="/admin/properties" element={<ProtectedAdmin><AdminProperties /></ProtectedAdmin>} />
            <Route path="/admin/properties/new" element={<ProtectedAdmin><PropertyForm /></ProtectedAdmin>} />
            <Route path="/admin/properties/:id/edit" element={<ProtectedAdmin><PropertyForm /></ProtectedAdmin>} />
            <Route path="/admin/leads" element={<ProtectedAdmin><AdminLeads /></ProtectedAdmin>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </GuestAuthProvider>
    </AuthProvider>
  );
}

export default App;
